import React from 'react'

export const LogoType = () => {

  return (
    <div style={styles.container()} id="logotype-container">
      <img src={process.env.PUBLIC_URL + "/masmovil.png"} alt={"masmovil"} className="logotype-image"/>
    </div>
  )
}

const styles = {
  container: () => ({
    display: 'flex', 
    justifyContent: 'center'
  })
}